import React from 'react';
import Button from '../common/Button';
import Assets from '../../Assets';

export default class EditorMobileNavigationBar extends React.PureComponent {
    render() {
        return (
            <div className="configuration-editor-mobile-nav-bar">
                <div className="configuration-editor-mobile-label" onClick={this.props.onDrawerToggleClick}>
                    <div className="configuration-editor-mobile-icon">
                        <img src={Assets.editorNavDrawer}/>

                        <span>{__('Step')} {this.props.currentStepIndex + 1} / {this.props.availableSteps.length}</span>
                    </div>

                    <div className="configuration-editor-mobile-step-name">
                        {this.props.currentStep ? this.props.currentStep.name : ''}
                    </div>
                </div>

                <div className="configuration-editor-mobile-arrows">
                    <Button
                        className="configuration-editor-mobile-arrow-left"
                        disabled={!this.props.isPreviousButtonActive}
                        theme={Button.Theme.TextOnly}
                        shape={Button.Shape.Circle}
                        onClick={this.props.onPreviousStepButtonClick}
                    >
                        <img
                            src={this.props.isPreviousButtonActive ? Assets.editorNavArrowWhite : Assets.editorNavArrowGray}/>
                    </Button>

                    {this.props.isOnLastStep ? (
                        <Button onClick={this.props.onNextStepButtonClick}>{__('Save')}</Button>
                    ) : (
                        <Button
                            className="configuration-editor-mobile-arrow-right"
                            theme={Button.Theme.TextOnly}
                            shape={Button.Shape.Circle}
                            onClick={this.props.onNextStepButtonClick}
                        >
                            <img src={Assets.editorNavArrowWhite}/>
                        </Button>
                    )}
                </div>
            </div>
        )
    }
}